<template lang="html">
  <div id="temporaryLecturePanel">
    <div>
      <p>生徒のお名前</p>
      <div class="student-name-block">
        <div>
          <p>氏名(必須)　　：<input id="fullname" type="text" v-model="fullname" @input="handleNameInput"/></p>
          <p>フリガナ(任意)：<input id="kana" type="text" v-model="kana" /></p>
        </div>
      </div>
    </div>
    <div>
      <slot>
      </slot>
    </div>
    <label id="hasTest" style="display: block;">配布物（確認テスト等）: <select v-model="hasTest" >
      <option :value="true">
        有り
      </option>
      <option :value="false">
        無し
      </option>
    </select></label>
    <input type="checkbox" v-model="isOnline" /> オンライン授業</input>
    <textarea id="message" v-model="message" placeholder="連絡事項" style="display: block;"></textarea>
    <button v-if="!isEdit" @click.prevent="reserve()">予約する</button>
    <template v-else>
      <button @click.prevent="reserve()">編集の完了をする</button>
      <button id="eraseButton" @click.prevent="deleteResv()" style="display: block;">予約の削除をする</button>
    </template>
    <button @click.prevent="cancel()">キャンセル</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  PREVIEWBOX_HIDE_POPUP,
  PREVIEWBOX_TIME_UPDATE,
  EDITINGBOX_TIME_UPDATE,
  RESERVATIONBOX_FINISH_EDIT,
  RESERVATION_HIDE_POPUP,
  EDITING_POPUP_HIDE,
  SPINNER_SHOW,
  SPINNER_HIDE
} from '@/vuex/mutation_types'
import * as Autokana from 'vanilla-autokana'

// Autokanaをbindするための変数
let autokana

export default {
  data () {
    return {
      fullname: '',
      kana: '',
      hasTest: false,
      message: '',
      type: '通常',
      status: '',
      isOnline: false
    }
  },
  props: [
    'teacher',
    'isEdit',
    'reservationType'
  ],
  mounted () {
    autokana = Autokana.bind('#fullname', '#kana', { katakana: true })
    if (this.isEdit) {
      this.fullname = this.$store.state.informationPopup.reservation.student.fullname
      this.kana = this.$store.state.informationPopup.reservation.student.kana
      this.status = this.$store.state.informationPopup.reservation.student.status
    }
  },
  methods: {
    ...mapActions([
      'addUser',
      'addLecture',
      'postReservation',
      'getReservations',
      'editReservation',
      'deleteReservation',
      'updateUserList',
      'getLectures',
      'getTemporalStudentByFullname',
      'getNotTemporalStudentByFullname',
      'changeFullname',
      'changeStatus',
      'deleteUser'
    ]),
    reserve () {
      if (this.fullname === '') {
        alert('生徒の名前が空欄です．')
        return
      }
      this.$store.commit(SPINNER_SHOW)
      // 編集中のとき、編集前の生徒とそのIDを保存しておく
      let preStudent = this.isEdit ? this.$store.state.informationPopup.reservation.student : 0
      let preId = this.isEdit ? preStudent.id : -2
      let temporalStudentId = -1
      // 指定された氏名と同じ「一時的でない」生徒がいるかどうかチェック
      this.getNotTemporalStudentByFullname(this.fullname)
      .then((res) => {
        // いた場合
        temporalStudentId = res.data.not_temporal_student
        // ステータスを更新
        this.updateStatus(temporalStudentId, 'normal', this.reservationType)
        // 新規生徒上書きの場合、その生徒を消すか打診
        if (this.isEdit && (preStudent.status === 'trial' || preStudent.status === 'temporal')) {
          this.deleteUserHandler(preId, preStudent.fullname)
        }
        return Promise.resolve()
      })
      .catch((err) => {
        if (err.response.status === 404) {
          // いなかった場合
          // 指定された氏名と同じ「一時的な」生徒がいるかどうかチェック
          return this.getTemporalStudentByFullname(this.fullname)
          .then((res) => {
            // いた場合
            temporalStudentId = res.data.temporal_student
            // 編集中の場合、編集前と同じ生徒でなければステータス変更
            if (!(preId === temporalStudentId)) {
              this.updateStatus(temporalStudentId, 'temporal', this.reservationType)
              // 新規生徒上書きの場合、その生徒を消すか打診
              if (preStudent.status === 'trial' || preStudent.status === 'temporal') {
                this.deleteUserHandler(preId, preStudent.fullname)
              }
            }
            // フリガナが３２１−０
            if (this.kana !== '') {
              return this.changeFullname({id: res.data.temporal_student, newFullname: this.fullname, newKana: this.kana}).then(() => {
                if (this.$store.state.userInfo.user_type === 'admin') {
                  // adminの場合はユーザ一覧を更新
                  this.updateUserList()
                }
              })
            } else {
              return Promise.resolve()
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              // いなかった場合
              // 編集中でないとき、または編集中で編集前の生徒が既存生のとき、一時的な生徒の登録
              if (!this.isEdit || (this.isEdit && this.status !== 'trial' && this.status !== 'temporal')) {
                let userName = 'tanki_' + Math.random().toString(36).slice(-8)
                let user = {
                  user_name: userName,
                  password: Math.random().toString(36).slice(-8),
                  fullname: this.fullname,
                  type: 'student',
                  kana: this.kana === '' ? '短期' : this.kana,
                  school_id: this.$store.state.userInfo.school_id,
                  status: this.reservationType === '体験' ? 'trial' : 'temporal'
                }
                return this.addUser(user)
                .then((res) => {
                  temporalStudentId = res.data.id
                  if (this.$store.state.userInfo.user_type === 'admin') {
                    // adminの場合はユーザ一覧を更新
                    this.updateUserList()
                  }
                })
              } else {
                // 編集中でかつ、短期または体験のみ（つまり新規生徒）であれば、生徒名変更
                temporalStudentId = this.$store.state.informationPopup.reservation.student.id
                return this.changeFullname({id: this.$store.state.informationPopup.reservation.student.id, newFullname: this.fullname, newKana: this.kana}).then(() => {
                  if (this.$store.state.userInfo.user_type === 'admin') {
                    // adminの場合はユーザ一覧を更新
                    this.updateUserList()
                  }
                })
              }
              /*
              新規予約の場合も編集の場合も，一時的な生徒を追加すべき
              既存のユーザの名前等を変更するのはまずい（正規生徒も変更されてしまう，他の先生と講義がある場合もある）
              if (!this.isEdit) {
                // 新規予約の場合
                let userName = 'tanki_' + Math.random().toString(36).slice(-8)
                let user = {
                  user_name: userName,
                  password: Math.random().toString(36).slice(-8),
                  fullname: this.fullname,
                  type: 'student',
                  kana: this.kana === '' ? '短期' : this.kana
                }
                return this.addUser(user)
                .then((res) => {
                  temporalStudentId = res.data.id
                  if (this.$store.state.userInfo.user_type === 'admin') {
                    // adminの場合はユーザ一覧を更新
                    this.updateUserList()
                  }
                })
              } /* else {
                // 編集の場合
                return this.changeFullname({id: this.$store.state.informationPopup.reservation.student.id, newFullname: this.fullname, newKana: this.kana}).then(() => {
                  if (this.$store.state.userInfo.user_type === 'admin') {
                    // adminの場合はユーザ一覧を更新
                    this.updateUserList()
                  }
                })

              }
              */
            } else {
              // その他のエラー
              return Promise.reject(err)
            }
          })
        } else {
          // その他のエラー
          return Promise.reject(err)
        }
      })
      .then(() => {
        // 講義情報の取得
        return this.getLectures({})
        .then(() => {
          let lectures = this.$store.state.lectureInfo
          let alreadyExists = false
          // 既に講義情報が存在するかチェック
          for (let lect of lectures) {
            if (lect.student.id === temporalStudentId && lect.teacher.id === this.teacher) {
              alreadyExists = true
              break
            }
          }
          // 存在しない場合のみ，講義情報を登録
          if (!alreadyExists) {
            // 講義情報の登録
            return this.addLecture({
              student: temporalStudentId,
              teacher: this.teacher
            })
            .then(() => {
              // 講義情報の更新
              return this.getLectures({})
            })
          }
        })
        .then((res) => {
          // 予約登録
          let rType = this.reservationType
          if (!this.isEdit) {
            // 編集でない = 新規登録の場合
            return this.postReservation({
              student: temporalStudentId,
              teacher: this.teacher,
              start_time: this.$store.state.previewBox.start,
              end_time: this.$store.state.previewBox.end,
              classroom: this.$store.state.previewBox.classroom,
              date: this.getCurDateFormated,
              has_test: this.hasTest,
              reservation_type: rType,
              message: this.message,
              school_id: this.$store.state.userInfo.school_id,
              online: this.isOnline
            })
          } else {
            // 編集の場合
            return this.editReservation({
              id: this.$store.state.editingState.id,
              reservation: {
                student: temporalStudentId,
                teacher: this.teacher,
                start_time: this.$store.state.editingState.start,
                end_time: this.$store.state.editingState.end,
                classroom: this.$store.state.editingState.classroom,
                date: this.getCurDateFormated,
                has_test: this.hasTest,
                reservation_type: rType,
                message: this.message,
                school_id: this.$store.state.userInfo.school_id,
                online: this.isOnline
              }
            })
          }
        })
        .then(() => {
          // 予約情報を更新
          return this.getReservations({
            all: 1,
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
      })
      .then(() => {
        // popupを閉じる
        this.$store.commit(PREVIEWBOX_HIDE_POPUP)
        this.$store.commit(RESERVATION_HIDE_POPUP)
        this.$store.commit(RESERVATIONBOX_FINISH_EDIT)
        // preview box を閉じる
        this.$store.commit(PREVIEWBOX_TIME_UPDATE,
          {
            start: '10:00',
            end: '10:00'
          }
        )
        this.$store.commit(SPINNER_HIDE)
        return Promise.resolve()
      })
      .catch((err) => {
        console.error(err)
        alert('予約に関してエラーが発生しました')
      })
    },
    deleteResv () {
      let ret = confirm('削除します．よろしいですか？')
      if (ret) {
        this.$store.commit(SPINNER_SHOW)
        this.deleteReservation(this.$store.state.editingState.id)
        .then((res) => {
          // 予約情報を更新
          this.getReservations({
            all: 1,
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        // popupを閉じる
        this.$store.commit(EDITING_POPUP_HIDE)
        // preview box を閉じる
        this.$store.commit(EDITINGBOX_TIME_UPDATE,
          {
            start: '10:00',
            end: '10:00'
          }
        )
        this.$store.commit(SPINNER_HIDE)
      }
    },
    cancel () {
      // popupを閉じる
      this.$store.commit(EDITING_POPUP_HIDE)
      this.$store.commit(RESERVATION_HIDE_POPUP)
      // preview box を閉じる
      this.$store.commit(EDITINGBOX_TIME_UPDATE,
        {
          start: '10:00',
          end: '10:00'
        }
      )
    },
    handleNameInput () {
      this.kana = autokana.getFurigana()
    },
    updateStatus (id, status, rsvType) {
      var newStatus = ''
      if (rsvType === '短期初回') {
        switch (status) {
          case 'normal':
            newStatus = 'temp/norm'
            break
          case 'temporal':
            newStatus = 'temp/temp'
            break
        }
      } else {
        switch (status) {
          case 'normal':
            break
          case 'temporal':
            newStatus = 'temp/temp'
            break
        }
      }
      if (newStatus !== '') {
        this.changeStatus({
          id: id,
          newStatus: newStatus
        })
      }
    },
    deleteUserHandler (id, name) {
      let yesno = confirm('編集前に新規登録されていたユーザー：「' + name + '」を削除しますか？')
      if (yesno) {
        this.deleteUser(id)
        .then((res) => {
          alert('ユーザーの削除に成功しました。')
          this.updateUserList()
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getCurDateFormated'
    ])
  }
}
</script>

<style lang="css" scoped>
.student-name-block {
  margin: 0px 10px 10px 10px;
  padding: 5px;
  font-size: 5vw;
}
#eraseButton {
  color: #ff6666;
}
button {
  font-size: 5vw;
  padding: 0;
  margin-top: 10px;
}
#hasTest {
  margin-top: 10px;
}
#message {
  margin-top: 6px;
  width: 90%;
  height : 60px;
  font-size: 5vw;
  color:#505050;
  border:solid 1px #ccc;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// SpTemporaryLecturePanel.vue?d36bcdf8